<template>
  <div class="page">
    <div class="content">
      <div class="title">
        <div class="name">换货</div>
      </div>
      <!-- 基础信息 -->
      <div class="base_info">
        <div class="info_title">商品信息</div>
        <div v-for="(x, index) in goodsList" :key="index">
          <goodsInfo :goodsData="x" />
        </div>
        <div class="address">
          <div class="pic_s">
            <img src="/assets/images/shunf.png" alt="" />
          </div>
          <div class="detail_info">【杭州市】您的快递已签收，签收人小A</div>
        </div>
      </div>
      <!-- <div class="tips">退换货支持运费险（预计赔付7元）</div> -->
      <!-- <div class="status">
        <div class="status_title">换货件数</div>
        <div class="status_name">数量：</div>
        <div class="count base">
          <div class="left">-</div>
          <div class="mid">1</div>
          <div class="right">+</div>
        </div>
      </div> -->
      <div class="way">
        <div class="way_top">
          <div class="top_title">寄件方式</div>
          <div class="top_content">
            <!-- <el-radio v-model="radio" :label="1">上门取件</el-radio> -->
            <el-radio v-model="radio" :label="2">自行寄回</el-radio>
          </div>
        </div>
        <div class="way_down">
          <div class="way_left">
            <div class="down_title">我的地址</div>
            <div class="down_content">
              小A 158****7513 环城南路66号浙江工商大学杭州商学院桐庐校区
            </div>
          </div>

          <div class="way_right">更换</div>
        </div>
      </div>
      <!-- <div class="upload">
        <div class="upload_top">
          <div class="top_left">上传凭证</div>
          <div class="top_right">选填</div>
        </div>
        <div class="upload_down">
          <el-upload
            class="upload-demo"
            action="#"
            :on-success="success"
            :show-file-list="false"
            list-type="picture-card"
          >
            <div class="crosshair"></div>
          </el-upload>
        </div>
      </div> -->
      <div class="other">
        <div class="other_top">
          <div class="top_left">补充描述</div>
          <div class="top_right">选填</div>
        </div>
        <div class="other_down">
          <el-input v-model="applyReason" :rows="5" type="textarea" />
        </div>
      </div>
      <div class="action">
        <el-button
          type="primary"
          class="submit-btn"
          :loading="submitting"
          @click="submitExchange"
        >
          提交换货申请
        </el-button>
      </div>
    </div>
    <div class="back" @click="closeMask('/')">
      <img src="@/assets/images/svg/back.svg" alt="" />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import goodsInfo from "@/components/goodsInfo.vue";
import { applyRefund } from "@/api/shopping";
import { useToast } from "vue-toast-notification";
// import SF from "@/assets/images/shunf.png";
// import firendsIcon from "@/assets/images/firends.png";
const router = useRouter();
// const avtiveType = ref("全部订单");
const radio = ref("");
const applyReason = ref("");
const submitting = ref(false);
const $toast = useToast();
const orderData = ref({});
const goodsList = ref([]);
const logisticsTraceList = ref([]);
// const radioData = ref([
//   {
//     name: "多拍/错拍/不想要",
//     id: "1",
//   },
//   {
//     name: "商家发错货",
//     id: "2",
//   },
//   {
//     name: "其他",
//     id: "8",
//   },
// ]);

onMounted(() => {
  const route = useRoute();
  const data = JSON.parse(route.query.data);
  console.log(data);
  fetchData(data);
});
const fetchData = (data) => {
  orderData.value = data;
  goodsList.value = data.items;
  logisticsTraceList.value = data.logisticsTraceList;
};
const closeMask = (url) => {
  router.push(url);
};

const submitExchange = async () => {
  if (!orderData.value || !orderData.value.id) {
    $toast.error("订单信息异常，无法提交售后", { position: "top" });
    return;
  }
  if (submitting.value) return;

  const baseReason = "换货申请";
  const finalReason = `${baseReason}${
    applyReason.value ? "；补充说明：" + applyReason.value : ""
  }`;

  submitting.value = true;
  try {
    const res = await applyRefund({
      id: orderData.value.id,
      refundReason: finalReason,
    });
    if (res && res.code === 200) {
      $toast.success("换货申请已提交", { position: "top" });
      router.push("/myOrder");
    }
  } catch (e) {
    console.error("提交换货申请失败", e);
    $toast.error("提交换货申请失败，请稍后重试", { position: "top" });
  } finally {
    submitting.value = false;
  }
};
// const handleType = (val) => {
//   avtiveType.value = val;
// };
// const success = () => {};
</script>
<style scoped lang="scss">
.page {
  background-color: transparent;
  position: relative;
  padding: 86px 240px 0 240px;
  .content {
    width: 1200px;
    margin: 0 auto;
    .title {
      display: flex;
      padding-top: 76px;
      .name {
        width: 346x;
        height: 51px;
        font-weight: bold;
        font-size: 40px;
        color: var(--ux-text-primary);
        line-height: 46.998px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-bottom: 34px;
      }
    }
    .base_info {
      width: 1200px;
      border-radius: 10px;
      opacity: 1;
      background: var(--ux-glass-bg);
      padding: 35px;
      .info_title {
        font-family: Source Han Sans;
        font-size: 24px;
        font-weight: 350;
        color: var(--ux-text-primary);
        padding: 0 0 21px 0px;
      }
      .address {
        display: flex;
        align-items: center;
        margin-top: 25px;
        .pic_s {
          width: 107px;
          height: 41px;
          img {
            width: 100%;
          }
        }
        .detail_info {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: 350;
          color: var(--ux-text-primary);
          opacity: 0.5;
          margin-left: 5px;
        }
      }
    }
    .tips {
      padding: 29px 0 21px 0;
      color: var(--ux-text-primary);
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      opacity: 0.5;
    }
    .status {
      width: 1200px;
      height: 94px;
      border-radius: 10px;
      opacity: 1;
      display: flex;
      align-items: center;
      background: var(--ux-glass-bg);
      color: var(--ux-text-primary);
      .status_title {
        font-family: Source Han Sans;
        font-size: 30px;
        font-weight: 350;
        color: var(--ux-text-primary);
        margin-left: 35px;
      }
      .status_name {
        width: 116px;
        height: 58px;
        line-height: 58px;
        text-align: center;

        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 350;
        margin-left: 135px;
      }
      .count {
        margin-right: 28px;
        display: flex;
        .left {
          width: 43px;
          height: 43px;
          background: var(--ux-surface-muted);
          opacity: 0.5;
          border-radius: 10px;
          font-weight: bold;
          font-size: 20.006px;
          color: var(--ux-text-primary);
          line-height: 43px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          &:hover {
            cursor: pointer;
          }
        }
        .mid {
          width: 84px;
          height: 43px;
          background: transparent;
          border-radius: 10px;
          border: 1px solid rgba(37, 37, 35, 0.5);
          color: var(--ux-text-primary);
          line-height: 43px;
          text-align: center;
          margin: 0 9.8px;
          font-weight: bold;
        }
        .right {
          width: 43px;
          height: 43px;
          background: var(--ux-surface-muted);
          opacity: 0.5;
          border-radius: 10px;
          font-weight: bold;
          font-size: 20.006px;
          color: var(--ux-text-primary);
          line-height: 43px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .reason {
      width: 1200px;
      border-radius: 10px;
      opacity: 1;
      background: var(--ux-glass-bg);
      display: flex;
      justify-content: space-between;
      margin-top: 31px;
      padding: 30px 35px;
      .reason_select {
        display: flex;
        color: var(--ux-text-primary);
        .reason_title {
          margin-right: 120px;
          font-family: Source Han Sans;
          font-size: 30px;
          font-weight: 350;
        }
        .select_list {
          width: 600px;

          .select_title {
            font-family: Source Han Sans;
            font-size: 20px;
            font-weight: 350;
            opacity: 0.5;
            margin-top: 12px;
          }
          .item_list {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            margin-top: 50px;
            .select_item {
              width: 50%;
              margin-bottom: 15px;
              ::v-deep .el-radio__label {
                font-family: Source Han Sans;
                font-size: 20px;
                font-weight: 350;
              }
            }
          }
          .input_text {
            width: 100%;
            textarea {
              width: 80%;
              border: none;
            }
          }
        }
      }
      .check {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 350;
        color: var(--ux-text-primary);
        cursor: pointer;
      }
    }
    .amount {
      width: 1200px;
      height: 94px;
      border-radius: 10px;
      opacity: 1;
      display: flex;
      align-items: center;
      background: var(--ux-glass-bg);
      color: var(--ux-text-primary);
      margin-top: 35px;
      .amount_title {
        font-family: Source Han Sans;
        font-size: 30px;
        font-weight: 350;
        color: var(--ux-text-primary);
        margin-left: 35px;
      }
      .amount_r {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 350;
        margin-left: 59px;
      }
      .amount_remake {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 350;
        margin-left: 51px;
        opacity: 0.5;
        margin-left: 59px;
      }
    }
    .way {
      width: 1200px;
      border-radius: 10px;
      opacity: 1;
      background: var(--ux-glass-bg);
      color: var(--ux-text-primary);
      margin-top: 35px;
      padding: 33px 35px;
      .way_top {
        display: flex;
        align-items: center;
        border-bottom: 0.5px solid var(--ios-separator);
        padding-bottom: 28px;
        .top_title {
          font-family: Source Han Sans;
          font-size: 30px;
          font-weight: 350;
          color: var(--ux-text-primary);
        }
        .top_content {
          margin-left: 270px;
          ::v-deep .el-radio__label {
            font-family: Source Han Sans;
            font-size: 20px;
            font-weight: 350;
          }
        }
      }
      .way_down {
        display: flex;
        align-items: center;
        padding-top: 28px;
        justify-content: space-between;
        .way_left {
          display: flex;
          align-items: center;
          .down_title {
            font-family: Source Han Sans;
            font-size: 30px;
            font-weight: 350;
            color: var(--ux-text-primary);
            margin-right: 150px;
          }
          .down_content {
            font-family: Source Han Sans;
            font-size: 20px;
            font-weight: 350;
            color: var(--ux-text-primary);
            opacity: 0.5;
          }
        }
        .way_right {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: 350;
          color: var(--ux-text-primary);
          opacity: 0.5;
        }
      }
    }
    .upload {
      width: 1200px;
      height: 357px;
      border-radius: 10px;
      opacity: 1;
      background: var(--ux-glass-bg);
      margin-top: 30px;
      padding: 33px 35px;
      .upload_top {
        display: flex;
        color: var(--ux-text-primary);
        align-items: center;
        .top_left {
          font-family: Source Han Sans;
          font-size: 30px;
          font-weight: 350;
        }
        .top_right {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: 350;
          opacity: 0.5;
          margin-left: 18px;
        }
      }
      .upload_down {
        width: 1131px;
        height: 233px;
        border-radius: 4px;
        opacity: 1;
        margin-top: 30px;
        background: var(--ux-card-bg);
        display: flex;
        align-items: center;
        padding-left: 35px;
        ::v-deep .el-upload--picture-card {
          --el-upload-picture-card-size: 1.8rem;
        }
        .crosshair {
          position: relative;
          width: 100px;
          height: 100px;
        }

        .crosshair::before,
        .crosshair::after {
          content: "";
          position: absolute;
          background-color: var(--ux-glass-border);
        }

        .crosshair::before {
          top: 50%;
          left: 0;
          width: 100%;
          height: 10px;
          transform: translateY(-50%);
          border-radius: 10px;
        }

        .crosshair::after {
          top: 0;
          left: 50%;
          width: 10px;
          height: 100%;
          transform: translateX(-50%);
          border-radius: 10px;
        }
      }
    }
    .other {
      width: 1200px;
      height: 233px;
      border-radius: 10px;
      opacity: 1;
      background: var(--ux-glass-bg);
      margin-top: 30px;
      padding: 33px 35px;
      margin-bottom: 47px;
      .other_top {
        display: flex;
        color: var(--ux-text-primary);
        align-items: center;
        .top_left {
          font-family: Source Han Sans;
          font-size: 30px;
          font-weight: 350;
        }
        .top_right {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: 350;
          opacity: 0.5;
          margin-left: 18px;
        }
      }
      .other_down {
        width: 1131px;
        height: 114px;
        border-radius: 4px;
        opacity: 1;
        margin-top: 30px;
        background: var(--ux-card-bg);
        display: flex;
        align-items: center;

        textarea {
          width: 100%;
          height: 100%;
          border: none;
        }
      }
    }
    .action {
      margin-top: 24px;
      text-align: right;
      .submit-btn {
        min-width: 180px;
      }
    }
  }
  .back {
    position: absolute;
    right: 28px;
    top: 28px;
    width: 48.006px;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
